import { AppState } from '../store';

export const selectNotifications = (store: AppState) =>
  store.snacks.notifications;
